import React from 'react'
import { Box } from 'theme-ui'
import Navigation from '../../components/Navigation'
import useSiteMetadata from '../../helpers/useSiteMetadata'
// import attachSocialIcons from '../../helpers/attachSocialIcons'

const styles = {
  navHeader: {
    display: [`none`, `block`],
    color: 'white'
  },
  wrapperStyle: {
    flexDirection: [`row`, `column`],
    ml: [0, 2],
    flexWrap: `wrap`,
    justifyContent: [`center`,`normal`],
    my: [3, 0],
    gap: [2, 0]
  },
  link: {
    mr:[4,0],
    color: 'white'
  },
  social: {
    color: 'white',
    mr:[4,0],
  }
}

export const FooterMenu = () => {
  const { footerMenu, social } = useSiteMetadata()

  return (
    <>
      {footerMenu.map(menu => (
        <Box key={`footer-menu-${menu.title}` } >
          <Navigation
            variant={['horizontal', 'vertical']}
            headingProps={{ variant: 'h4', as: 'p', sx: styles.navHeader }}
            items={[menu]}
            wrapperStyle={styles.wrapperStyle}
            sx={styles.link}
            color='white'
          />
        {/* <Navigation
        items={attachSocialIcons(social)}
        variant={[`horizontal`, `vertical`]}
        sx={styles.social}
        /> */}
        </Box>
      ))}
    </>
  )
}
